import './App.css';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import DownloadApp from './pages/DownloadApp.js';

function App() {
  useEffect(() => {
    const handleBeforeInstallPrompt = e => {
      e.preventDefault(); // Suppress automatic install popup
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        'beforeinstallprompt',
        handleBeforeInstallPrompt
      );
    };
  }, []);

  useEffect(() => {
    const handleDeepLinks = () => {
      const userAgent = navigator.userAgent || navigator.vendor || '';
      const isAndroid = /android/i.test(userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(userAgent);

      // Store config
      const playStoreBaseURL = 'https://play.google.com/store/apps/details';
      const androidPackage = 'com.tringbox.tringuser';
      const appStoreBaseURL =
        'https://apps.apple.com/in/app/tringbox/id6748858527';

      const path = window.location.pathname;
      const search = window.location.search;

      // A deep link is any /launch or /launch/... URL
      const isLaunchLink = path === '/launch' || path.startsWith('/launch/');

      // Not a deep link -> just show the Download App page (no website access)
      if (!isLaunchLink) {
        return;
      }

      // Strip the /launch prefix to get the real target path
      // e.g. /launch/venues/123 -> /venues/123 ; /launch -> /
      const deepLinkPath =
        path === '/launch' ? '/' : path.replace('/launch', '');

      // Read query params. `isredirect` is a web-only control flag and must NOT
      // be forwarded into the app / store deep link.
      const params = new URLSearchParams(search);
      const trackId = params.get('trackId');
      const isRedirect = params.get('isredirect') === 'true';
      params.delete('isredirect');
      const cleanedSearch = params.toString() ? `?${params.toString()}` : '';

      // Keep the (cleaned) query string so params like ?trackId= / ?referralCode= survive
      const deepLinkTarget = deepLinkPath + cleanedSearch;

      // Track links normally fall back to the web player instead of the store.
      // Exception: if `isredirect=true` is also present, use the store DDL instead.
      const isTrackWebFallback = !!trackId && !isRedirect;
      const trackWebURL = `https://player.tringbox.ai/track/?trackId=${trackId}`;

      // Deferred deep link for the Play Store: referrer = deep_link=<encoded target>
      // e.g. /track?trackId=abc -> referrer=deep_link%3D%252Ftrack%253FtrackId%253Dabc
      const referrer = 'deep_link=' + encodeURIComponent(deepLinkTarget);
      const encodedReferrer = encodeURIComponent(referrer);
      const playStoreMarketURL = `intent://details?id=${androidPackage}&referrer=${encodedReferrer}#Intent;scheme=market;package=com.android.vending;end`;
      const playStoreWebURL = `${playStoreBaseURL}?id=${androidPackage}&referrer=${encodedReferrer}`;

      if (isAndroid || isIOS) {
        window.history.replaceState({}, '', deepLinkTarget);

        // Try opening the app (routes inside the app if installed)
        const customSchemeURL = `tringbox://${deepLinkTarget.replace(/^\//, '')}`;
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = customSchemeURL;
        document.body.appendChild(iframe);

        // Fallback if the app is not installed:
        //  - track links without isredirect -> web player
        //  - Android -> market:// (directly opens Play Store App)
        //  - iOS -> App Store URL
        const fallbackURL = isTrackWebFallback
          ? trackWebURL
          : isAndroid
            ? playStoreMarketURL
            : appStoreBaseURL;

        const fallbackTimer = setTimeout(() => {
          if (!document.hidden) {
            window.location.href = fallbackURL;
            if (isAndroid && !isTrackWebFallback) {
              // Secondary fallback to web store if market:// isn't handled
              setTimeout(() => {
                if (!document.hidden) {
                  window.location.href = playStoreWebURL;
                }
              }, 1000);
            }
          }
        }, 350);

        const cleanup = () => {
          clearTimeout(fallbackTimer);
        };
        window.addEventListener('pagehide', cleanup);
        window.addEventListener('visibilitychange', () => {
          if (document.hidden) cleanup();
        });
      } else {
        // Desktop - track links go to the web player, everything else shows download page
        if (isTrackWebFallback) {
          window.location.href = trackWebURL;
        }
        // For all other desktop deep links, the Download App page will show
      }
    };

    handleDeepLinks();
  }, []);

  // Show the Download App page on all devices (mobile + desktop)
  return <DownloadApp />;
}

export default App;
